/**
 * 巡检管理（inspectionManagement）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/inspectionManagement/ 下 MeterAreaModal、PipelineManagement、
 *          ProblemManagement（含 Outsourcing 变体）等
 * 术语：巡检=Inspection，巡检计划=Inspection Plan，巡检任务=Inspection Task，
 *       隐患=Hidden Danger，管线=Pipeline，点位=Point，打卡=Clock In，
 *       漏检=Missed Inspection，异常上报=Abnormality Report，
 *       外包=Outsourcing，营收=Revenue，水厂=Water Plant
 */
export default {
  // 通用词（与 en-US.js 保持一致，模块内自包含）
  '确定': 'OK',
  '未查询到数据！': 'No data found!',
  '确认': 'Confirm',
  '关闭': 'Close',
  '查询': 'Query',
  '重置': 'Reset',
  '删除': 'Delete',
  '详情': 'Details',
  '批量操作': 'Batch Operations',
  '操作': 'Action',
  '创建时间': 'Created At',
  '是': 'Yes',
  '否': 'No',
  // 区域（MeterAreaModal）
  '上级区域': 'Parent Area',
  '请选择上级区域': 'Please select parent area',
  '区域名称': 'Area Name',
  '请输入区域名称': 'Please enter area name',
  '负责人': 'Person in Charge',
  '请输入负责人': 'Please enter person in charge',
  '负责人电话': 'Person in Charge Phone',
  '请输入负责人电话': 'Please enter person in charge phone',
  '小区备注信息': 'Community Remarks',
  '请输入小区备注信息': 'Please enter community remarks',
  '请输入区域/小区名称!': 'Please enter the area/community name!',
  '您的手机号码格式不正确!': 'Invalid mobile phone number format!',
  // 问题管理（ProblemManagement 及外包变体）
  '问题确认': 'Problem Confirmation',
  '问题处理': 'Problem Handling',
  '问题记录': 'Problem Records',
  '问题上报': 'Problem Reporting',
  '问题详情': 'Problem Details',
  '问题等级': 'Problem Level',
  '请选择问题等级': 'Select problem level',
  '问题描述': 'Problem Description',
  '上报人': 'Reporter',
  '上报人电话': 'Reporter Phone',
  '现场坐标': 'On-site Coordinates',
  '设备编号': 'Device No.',
  '设备类型': 'Device Type',
  '请选择设备类型': 'Please select device type',
  '设备名称': 'Device Name',
  '状态': 'Status',
  '请选择状态': 'Select status',
  '时间范围': 'Time Range',
  '未确认': 'Unconfirmed',
  '已确认': 'Confirmed',
  '驳回': 'Reject',
  '搁置': 'On Hold',
  '已完成': 'Completed',
  '工单处理中': 'Work Order Processing',
  '关联工单': 'Related Work Order',
  '处理': 'Handle',
  '处理人': 'Handler',
  '请选择处理人': 'Please select handler',
  '处理时间': 'Handling Time',
  '处理信息': 'Handling Info',
  '处理图片': 'Handling Photos',
  '请选择处理照片': 'Please select handling photos',
  '处理描述': 'Handling Description',
  '请输入处理描述': 'Please enter handling description',
  '处理前图片或视频': 'Photos/Videos Before Handling',
  '处理后图片或视频': 'Photos/Videos After Handling',
  '现场图片或视频': 'On-site Photos or Videos',
  '是否现场已解决': 'Resolved On Site',
  '已解决': 'Resolved',
  '未解决': 'Unresolved',
  '检测实体': 'Detected Entity',
  '确认信息': 'Confirmation Info',
  '确认人': 'Confirmer',
  '确认描述': 'Confirmation Description',
  '审批描述': 'Approval Description',
  '请输入审批描述': 'Please enter approval description',
  '是否开启工单': 'Create Work Order or Not',
  '请选择是否开启工单': 'Please select whether to create a work order',
  '驳回信息': 'Rejection Info',
  '驳回时间': 'Rejection Time',
  '驳回原因': 'Rejection Reason',
  '请输入驳回原因': 'Please enter rejection reason',
  '驳回成功！': 'Rejected successfully!',
  '搁置信息': 'On-hold Info',
  '搁置时间': 'On-hold Time',
  '搁置原因': 'On-hold Reason',
  '请输入搁置原因': 'Please enter on-hold reason',
  '搁置成功！': 'Put on hold successfully!',
  // 工单生成（ConfirmIsOrderModal）
  '工单类型': 'Work Order Type',
  '请选择工单类型': 'Please select work order type',
  '故障报修': 'Fault Repair',
  '水厂报修': 'Water Plant Repair',
  '工单联系人': 'Work Order Contact',
  '请输入工单联系人': 'Please enter work order contact',
  '联系电话': 'Contact Phone',
  '请输入联系电话': 'Please enter contact phone',
  '紧急程度': 'Urgency',
  '请选择紧急程度': 'Please select urgency',
  '请选择工单紧急程度': 'Please select work order urgency',
  '地理信息': 'Geographic Info',
  '请输入工单位置': 'Please enter work order location',
  '预约时间': 'Appointment Time',
  '生成工单成功！': 'Work order created successfully!',
  '请输入回复内容': 'Please enter reply content',
  // 其他
  '上传': 'Upload',
  '下载': 'Download',
  '预览': 'Preview',
  '无图片': 'No Image',
  '无文件': 'No File',
  '普通处理界面': 'Normal Handling Interface',
}
